import { routes } from './routes';

export const resourcesHelperObject = [
  {
    label: 'Help Center',
    link: routes.comingSoon.root,
  },
  {
    label: 'Platform Status',
    link: routes.comingSoon.root,
  },
  {
    label: 'Partners',
    link: routes.comingSoon.root,
  },
  {
    label: 'Suggestions',
    link: routes.comingSoon.root,
  },
  {
    label: 'Discord Community',
    link: routes.comingSoon.root,
  },
  {
    label: 'Blog',
    link: routes.comingSoon.root,
  },
  {
    label: 'Docs',
    link: routes.comingSoon.root,
  },
  {
    label: 'Newsletter',
    link: routes.comingSoon.root,
  },
];
